
import { getVertexshaderSource, getFragmentShaderSource } from "../webgl/shaders";
import { createProgram } from "../webgl/program";
import { mat3 } from "gl-matrix";
import { resetWebGLMatrices } from "../utils/matrixHelpers";
import { resizeCanvasToDisplaySize } from "../common";

export class g {
    static _glCanvas: HTMLCanvasElement;
    static _canvasWidth: number;
    static _canvasHeight: number;
    static _u_color: WebGLUniformLocation | null;
    static _u_pan: WebGLUniformLocation | null;
    static _u_move: WebGLUniformLocation | null;
    static _u_rotate: WebGLUniformLocation | null;
    static _u_scale: WebGLUniformLocation | null;
    static _u_resolution: WebGLUniformLocation | null;
    static _webglContext: WebGLRenderingContext | null;

    static get canvas() {
        return this._glCanvas;
    }

    static set canvas(v) {
        this._glCanvas = v;
    }

    static get context() {
        return this._webglContext;
    }
    static set context(v) {
        this._webglContext = v;
    }

    static get canvasWidth() {
        return this._canvasWidth;
    }

    static set canvasWidth(v) {
        this._canvasWidth = v;
    }

    static get canvasHeight() {
        return this._canvasHeight;
    }

    static set canvasHeight(v) {
        this._canvasHeight = v;
    }


    static get u_color() {
        return this._u_color;
    }
    static set u_color(v) {
        this._u_color = v;
    }

    static get u_pan() {
        return this._u_pan;
    }
    static set u_pan(v) {
        this._u_pan = v;
    }

    static get u_move() {
        return this._u_move;
    }
    static set u_move(v) {
        this._u_move = v;
    }

    static get u_rotate() {
        return this._u_rotate;
    }
    static set u_rotate(v) {
        this._u_rotate = v;
    }

    static get u_scale() {
        return this._u_scale;
    }
    static set u_scale(v) {
        this._u_scale = v;
    }

    static get u_resolution() {
        return this._u_resolution;
    }
    static set u_resolution(v) {
        this._u_resolution = v;
    }

    static init(canvasEl: HTMLCanvasElement) {
        this.canvas = canvasEl;
        resizeCanvasToDisplaySize(this.canvas);
        const context = this.canvas.getContext('webgl2');
        if (!context) {
            throw new Error('WebGL2 context not available');
        }
        this.context = context;
        const program = createProgram(context, getVertexshaderSource(), getFragmentShaderSource());
        context.useProgram(program);
        context.viewport(0, 0, this.canvas.width, this.canvas.height);
        context.enable(context.BLEND);
        context.blendFunc(context.SRC_ALPHA, context.ONE_MINUS_SRC_ALPHA);

        const a_position = context.getAttribLocation(program, 'a_position');

        const vertex_buffer = context.createBuffer();
        context.bindBuffer(context.ARRAY_BUFFER, vertex_buffer);
        context.enableVertexAttribArray(a_position);
        context.vertexAttribPointer(a_position, 2, context.FLOAT, false, 0, 0); // это переключение буфера на указатель a_position


        this.u_color = context.getUniformLocation(program, 'u_color');
        this.u_pan = context.getUniformLocation(program, 'u_pan');
        this.u_move = context.getUniformLocation(program, 'u_move');
        this.u_rotate = context.getUniformLocation(program, 'u_rotate');
        this.u_scale = context.getUniformLocation(program, 'u_scale');
        this.u_resolution = context.getUniformLocation(program, 'u_resolution');

        if (this.u_color) {
            context.uniform4f(this.u_color, 1, 0, 0, 1);
        }
        if (this.u_move && this.u_rotate && this.u_scale && this.u_pan) {
            resetWebGLMatrices(context, {
                u_move: this.u_move,
                u_rotate: this.u_rotate,
                u_scale: this.u_scale,
                u_pan: this.u_pan
            });
        }
        if (this.u_resolution) {
            context.uniform2f(this.u_resolution, context.canvas.width, context.canvas.height);
        }
    }

}